import { useState, useEffect } from 'react';
import { natsClient } from '../services/NATSClient';

export interface NATSStatus {
  isConnected: boolean;
  isConnecting: boolean;
  error: string | null;
  lastConnected: Date | null;
}

export const useNATSStatus = () => {
  const [status, setStatus] = useState<NATSStatus>({
    isConnected: false,
    isConnecting: false,
    error: null,
    lastConnected: null
  });

  useEffect(() => {
    // Status callback function
    const statusCallback = (natsStatus: { 
      isConnected: boolean; 
      error?: string; 
      lastConnected?: Date | null 
    }) => {
      setStatus(prev => ({
        ...prev,
        isConnected: natsStatus.isConnected,
        error: natsStatus.error || null,
        lastConnected: natsStatus.lastConnected || null,
        isConnecting: false
      }));
    };

    // Subscribe to status changes
    natsClient.onStatusChange(statusCallback);

    // Cleanup
    return () => {
      natsClient.offStatusChange(statusCallback);
    };
  }, []);

  return status;
};
